import React from 'react';
import styles from './ProjectCardInfo.module.scss';
import { ProjectValue } from '../../../../../../../Models/ProjectValue';
import { ProjectCardSummary } from './ProjectCardSummary/ProjectCardSummary';
import { ProjectCardDetailsList } from './ProjectCardDetailsList/ProjectCardDetailsList';

export interface ProjectCardInfoProps {
  className?: string;
  project: ProjectValue;
  onSeeDateRowReports: (index: number) => void;
}

export const ProjectCardInfo = ({
  className = '',
  project,
  onSeeDateRowReports
}: ProjectCardInfoProps): React.ReactElement<ProjectCardInfoProps> => {
  return (
    <div className={`${styles.projectCardInfo} ${className}`}>
      <ProjectCardSummary
        startDate={project.start_date}
        endDate={project.end_date}
        progress={project.progress}
        allDay={project.all_day}
      />
      <ProjectCardDetailsList
        counters={project.counters}
        rows={project.rows}
        onSeeDateRowReports={onSeeDateRowReports}
      />
    </div>
  );
};
